import { homeReducer } from '../home/homeActions';
import { loginReducer } from '../login/loginActions';

/**
 * 共通プロジェクトのreducer群。
 * reducerを追加したら、ここにも追加すること。
 */
const commonReducers = {
  commonLogin: loginReducer,
  home: homeReducer,
};

export default commonReducers;

